import { z } from 'zod';

const UploadZeeDocumentFormSchema = z.object({
  file: z.instanceof(File).refine((value) => value !== null, {
    message: 'Please upload your file',
  }),
  file_name: z.string().min(1, {
    message: "Title can't be empty",
  }),
});

export { UploadZeeDocumentFormSchema };
